import React from 'react';
import {Formik} from 'formik';
import yup from '../../../utils/yup';
import {useSelector} from 'react-redux';
import RequestForm from './RequestForm';
import {toast} from 'react-toastify';
import {Trans, useTranslation} from 'react-i18next';
import dao from '../../../dao/supportDao';
import AccountPortlet from '../../generalsettings/accountsettings/updateaccount/components/AccountPortlet';
import TechnicalSupportPortlet from './components/TechnicalSupportPortlet';

export default function AddRequest() {
  const {t} = useTranslation();
  const {account, customer} = useSelector(
    s => s.components.auth.accountSummary
  );
  const functionType = customer.functionType;

  const formikConfig = {
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: yup.object().shape({
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      email: yup
        .string()
        .email()
        .required(),
      questionType: yup.string().required(),
      description: yup.string().required(),
    }),
    initialValues: {
      supportType: 'ENDUSERS',
      languageType: account.languageType,
      firstName: account.firstName,
      lastName: account.lastName,
      email: account.email,
      questionType: '',
      description: '',
      websiteUrl: customer.websiteUrl || '',
      numberOfEmployees: customer.numberOfEmployees,
      businessName: customer.customerName,
      businessType: customer.businessType,
      phone: customer.phone,
      address: customer.address,
      city: customer.city,
      zipCode: customer.zipCode,
      state: customer.state,
      country: customer.country,
      files: [],
    },
    onSubmit: ({files, ...values}, {resetForm, setSubmitting}) => {
      dao
        .createRequest(values, files)
        .then(() => {
          toast.success(
            t(
              'p.c.addrequest.submit.success',
              'Thank you for the feedback!\nOur support representative will get in touch with you.'
            ),
            {
              autoClose: 5000,
            }
          );
          resetForm();
        })
        .catch(() => {
          toast.error(t('p.c.addrequest.submit.failed', 'Failed.'), {
            autoClose: 1000,
          });
          setSubmitting(false);
        });
    },
  };

  return (
    <>
      <AccountPortlet
        title={
          <Trans i18nKey="p.c.addrequest.submit.form">Submit a Form</Trans>
        }
        body={
          <div className="kt-portlet kt-portlet--mobile kt-portlet--bordered kt-margin-b-20">
            <div className="kt-portlet__body">
              <Formik {...formikConfig}>
                {props => <RequestForm {...props} />}
              </Formik>{' '}
            </div>
          </div>
        }
      />
      {functionType === 'SKINCARE_PRO' && <TechnicalSupportPortlet />}
    </>
  );
}
